import { render, staticRenderFns } from "./PurchasesGalleryFeed.vue?vue&type=template&id=d91c42e6&scoped=true&"
import script from "./PurchasesGalleryFeed.vue?vue&type=script&lang=ts&"
export * from "./PurchasesGalleryFeed.vue?vue&type=script&lang=ts&"
import style0 from "./PurchasesGalleryFeed.vue?vue&type=style&index=0&id=d91c42e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91c42e6",
  null
  
)

export default component.exports